import React from "react";
import { Avatar, Button, Menu, MenuHandler, MenuList } from "../material-old";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { Space } from "antd";
import { navbarProfileItems } from "./fixtures/navbarProfileItems.tsx";
import NavbarProfileItem from "./NavbarProfileItem.tsx";
import NotificationBell from "../common/NotificationBell.tsx";
import { useAppSelector } from "../../redux/hooks.ts";

export default function NavbarProfile() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const { userInfo } = useAppSelector((state) => state.auth);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <div className="flex items-center gap-2">
      {userInfo?.is_validated && (
        <Space className="p-2">
          <NotificationBell />
        </Space>
      )}
      <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end">
        <MenuHandler>
          <Button
            variant="text"
            color="blue-gray"
            className="flex items-center gap-1 rounded-full py-0.5 pr-2 pl-0.5 lg:ml-auto"
          >
            <Avatar
              variant="circular"
              size="sm"
              alt="tania andrew"
              className="border border-gray-900 p-0.5"
              src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1480&q=80"
            />
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`h-3 w-3 transition-transform ${
                isMenuOpen ? "rotate-180" : ""
              }`}
            />
          </Button>
        </MenuHandler>
        <MenuList className="p-1">
        {navbarProfileItems.map(
          ({ label, icon, href, requiresUserId, fallbackHref }, key) => {
            const isLastItem = key === navbarProfileItems.length - 1;

            // Handle dynamic href (/:user_id) with proper fallback
            let finalHref = href;
            if (requiresUserId) {
              if (userInfo?.id) {
                finalHref = `${href}${userInfo.id}`;
              } else {
                finalHref = fallbackHref || "/"; // Safe fallback
              }
            }

            if (requiresUserId && !userInfo?.id) {
              return null; // Gracefully hide the menu item
            }

            return (
              <NavbarProfileItem
                key={label}
                label={label}
                icon={icon}
                isLastItem={isLastItem}
                closeMenu={closeMenu}
                href={finalHref}
              />
            );
          },
        )}
        </MenuList>
      </Menu>
    </div>
  );
}
